import { Component} from '@angular/core';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { Platform } from '@angular/cdk/platform';
import { ApiService } from '../api.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { LocationService } from '../location.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {

  constructor(private auth: AuthService,
    public handler: HandlerService,
      public platform: Platform,
      public service: ApiService,
      public router: Router,
    private bottomSheet: MatBottomSheet,
    public location: LocationService 
    ) { }

  loader:boolean; pic; numCd = "+91"; numb; name; 
  code; tag; web; email; desc; pic1; stateId; cityId; regionId; houseNbr;street; zipcode;
  categoryObj:any;
  categoryName;
  url;
  categoryId;
  OrgTypeObj=[{name:'Single Org',id:1},{name:'franchisor',id:2},{name:'Franchisee',id:3}];
  orgType;
  gstNbr;
  orgTypeName;
  fontStyle;
  franchisorObj:any;
  franchisorName;
  franchisorId;
  newSearch;
  selectedCat;
  catArray:any=[];
  ionViewWillEnter() {
    this.url = window.location.href;
    this.fontStyle = localStorage.getItem('lang');
    JSON.parse(sessionStorage.getItem('category')).map(res=>{
     this.catArray.push(res.id)
    })
  }

  checkMob(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    this.numb = event.target.value;
  }

  next() {
  
    if(this.numb.length==10){
      this.loader=true;
    if(this.name){
      this.name = this.name.toUpperCase();
    }
    if(this.code){
      this.code = this.code.toUpperCase();
    }  
    var post = {
     "name": this.name,
      "code": this.code,
      "website": this.web,
      "logo": this.pic,
      "tagline": this.tag,
      "langCode": "101",
      "contactNbrMob": this.numCd + this.numb,
      "emailId": this.email,
      "activeInd":true,
      "franchisorId":790,
      "orgType":3,
      // "gstNumber":this.gstNbr,
      "categories":this.catArray,

    };  
    if(this.url.includes('Org-register')){
      Object.assign(post,{franchisorId:localStorage.getItem('organizationId')})
    }else{
      Object.assign(post,{franchisorId:790})
    }
    this.loader = true;
    this.service.orgRegister(post).subscribe((res:any) => {
      this.loader = false;
      // this.handler.res('Registered Successfully !!');
      setTimeout(() => {
        this.handler.res('Org Registration is Successful and Pending Approval');
        this.loader=false;
        let url: any = window.location.href.split('/').pop();
        if (res.orgType==3){
          sessionStorage.setItem('type', 'SP');
        }else
          {
          sessionStorage.setItem('type', 'MNGORG'); }
         localStorage.setItem('orgDetail',JSON.stringify(res))       
         if(this.url.includes('Org-register')){
          this.router.navigate(['/manage-org']);  
         }else{
          this.router.navigate(['/adminReg']);
         }    
      }, 2000);
    }, err => {
      this.loader = false;
      this.handler.err(err);
    })
    if(this.url.includes('Org-register')){
      this.router.navigate(['/manage-org']);  
     }else{
      this.router.navigate(['/adminReg']);
     }
    }else{
      this.handler.staticError('Please enter valid mobile number')
    }
  }

  handleFile(files) {
    if(files[0].size < 1048576){
    var img = new Image();
    img.src = URL.createObjectURL(files[0]);
    img.onload = (data)=>{
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0,0);  
      this.pic = canvas.toDataURL('image/jpeg',0.07);
    }
  }
  else{
    this.handler.res('Image Size Should Not Exceeds 1mb ');
  }
  }
 
 
 
  ionViewWillLeave() {
    this.name = "";
    this.code = "";
    this.numb = "";
    this.tag = "";
    this.web = "";
    this.email = "";
    this.pic = "";
  }
}
